import './ComeNasce.css';

const ComeNasce = () => {

  return (
    <div class="max-h-[calc(100vh-86px)] overflow-y-auto flex flex-col justify-between h-full">
        <main class="max-w-3xl mx-auto w-full px-4 py-8">
            <header class="text-center mb-10">
                <h1 class="text-3xl font-serif mb-2 tracking-wide">Il Processo Creativo</h1>
                <p class="text-stone-500 text-sm italic">La nostra filosofia di produzione lenta.</p>
            </header>

            <div class="space-y-10">
                <div class="flex flex-col sm:flex-row gap-4 items-start">
                    <div class="text-2xl font-serif text-stone-300 sm:w-1/4">01 / Ispirazione</div>
                    <div class="sm:w-3/4">
                        <h3 class="text-lg font-serif mb-1">Lo schizzo</h3>
                        <p class="text-stone-600 text-sm leading-relaxed">Tutto inizia con un disegno a mano libera, unendo il classicismo della tradizione con le esigenze contemporanee.</p>
                    </div>
                </div>
                <div class="flex flex-col sm:flex-row gap-4 items-start">
                    <div class="text-2xl font-serif text-stone-300 sm:w-1/4">02 / Materia</div>
                    <div class="sm:w-3/4">
                        <h3 class="text-lg font-serif mb-1">Fibre naturali</h3>
                        <p class="text-stone-600 text-sm leading-relaxed">Selezioniamo solo filati da fornitori certificati. Seta grezza, lino biologico e lane finissime.</p>
                    </div>
                </div>
            </div>
        </main>

    </div>
  );
};

export default ComeNasce;
